import React, { forwardRef, useEffect } from 'react';
import TextInputStyled from './bundle.esm2.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TextInput = forwardRef((props, ref) => {
  const _a = props, { label, name, id, className, errorMessage } = _a, rest = __objRest(_a, ["label", "name", "id", "className", "errorMessage"]);
  const errorMessageId = `${id != null ? id : name}-error`;
  const renderLabel = () => {
    if (!label)
      return null;
    return /* @__PURE__ */ React.createElement("label", {
      className: "TextInput__label",
      htmlFor: id != null ? id : name
    }, label);
  };
  const renderErrorMessage = () => {
    if (!errorMessage)
      return null;
    if (typeof errorMessage === "string") {
      return /* @__PURE__ */ React.createElement("span", {
        id: errorMessageId,
        className: "TextInput__errorMessage"
      }, errorMessage);
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: "TextInput__errorMessage"
    }, errorMessage);
  };
  useEffect(() => {
    if (name || !label)
      return;
    console.warn(
      "TextInput: When using the label tag consider passing the 'name' prop"
    );
  }, [name, label]);
  useEffect(() => {
    if (name || id || !errorMessage)
      return;
    console.warn(
      "Switch: If you want to display an error consider passing the 'name' prop or 'id' prop or both"
    );
  }, [name, id, errorMessage]);
  return /* @__PURE__ */ React.createElement(TextInputStyled, {
    className: `TextInput ${className}`
  }, renderLabel(), /* @__PURE__ */ React.createElement("input", __spreadProps(__spreadValues({
    className: "TextInput__input",
    id: id != null ? id : name,
    type: "text",
    name,
    maxLength: 80,
    "aria-invalid": errorMessage ? "true" : "false",
    "aria-errormessage": errorMessageId
  }, rest), {
    ref
  })), renderErrorMessage());
});
TextInput.defaultProps = {
  className: ""
};

export { TextInput as default };
//# sourceMappingURL=bundle.esm.js.map
